var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStudioTab = function SvgStudioTab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 17.418a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0zm11-1.836a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0zm-11 1.833V7.332m11 8.251V5.5",
    stroke: "currentColor",
    strokeWidth: 1.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.424 3.441-3.667 1.222c-1.21.404-1.815.605-2.16 1.086-.347.48-.347 1.117-.347 2.393v2.857l11-3.667V6.92c0-2.322 0-3.482-.761-4.031-.762-.549-1.863-.182-4.065.552z",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })));
};
export default SvgStudioTab;